module.exports = __webpack_public_path__ + "static/media/g-1-b.b3d7d5d4.jpg";